import React from 'react'
import { t } from 'ttag'
import './SignUpCodeStatus.scss'

interface ISignUpCodeStatus {
  expiresAt: string | null
  usageLimit: number | null
  usageCount: number
}

export default function SignUpCodeStatus(props: ISignUpCodeStatus) {
  const { expiresAt, usageLimit, usageCount } = props

  const isExpired = expiresAt != null && new Date(expiresAt) < new Date()
  const isLimitReached = usageLimit != null && usageCount >= usageLimit

  const status = isExpired ? 'expired' : isLimitReached ? 'limit-reached' : 'active'

  const label = () => {
    switch (status) {
      case 'active':
        return t`Active`
      case 'expired':
        return t`Expired`
      case 'limit-reached':
        return t`Limit reached`
      default:
        return status
    }
  }

  return (
    <div className={`sign-up-code-status sign-up-code-status__${status}`}>
      <span className="sign-up-code-status-dot"></span>
      {label()}
    </div>
  )
}
